import React from 'react';
import { Link } from 'react-router-dom';
import { urlFor } from '../sanity/sanityClient';
import './RecommendedProducts.css';

const RecommendedProducts = ({ products, handleProductView }) => {
  if (!products || products.length === 0) return null;

  return (
    <section className="rp-root" aria-label="Recommended products">
      <div className="rp-track">
        {products.map((product, index) => (
          <article key={`${product._id}-${index}`} className="rp-card">
            <Link
              className="rp-media"
              to={`/category/${product.slug.current}`}
              onClick={() => handleProductView(product._id, product._type)}
            >
              <img
                className="rp-img"
                src={urlFor(product.image[0])}
                alt={product.name}
                loading="lazy"
                draggable={false}
              />

              {product.status && (
                <span
                  className={`rp-badge${
                    product.status === 'soldout' ? ' rp-badge--soldout' : ''
                  }`}
                >
                  {product.status}
                </span>
              )}
            </Link>

            <div className="rp-body">
              <p className="rp-price">
                {product.currency ? product.currency : 'Tzs'}:{' '}
                {product.price?.toLocaleString()}/=
              </p>
              <p className="rp-name">{product.name}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default RecommendedProducts;